import { eKeHoachKyHieuActionsObj } from "../../action-types/ke-hoach/IKeHoachKyHieuActions";
import { generateActions } from "../generateActions";

export const keHoachKyHieuActions = {
  ...generateActions(eKeHoachKyHieuActionsObj, "KE_HOACH_KY_HIEU"),
};
